import classNames from "classnames";
import { ErrorMessage, useField, useFormikContext } from "formik";
import React, { ReactNode } from "react";
import { FloatingLabel, Form, FormControlProps } from "react-bootstrap";
import PopoverBtn from "../popoverBtn";

interface IInputTextProps extends FormControlProps {
  placeholderHTML?: string;
  popoverText?: string;
  prefixIcon?: ReactNode;
  isValidateImmediate?: boolean;
}
export default function InputText({
  className,
  placeholderHTML,
  popoverText,
  prefixIcon,
  isValidateImmediate = false,
  ...props
}: IInputTextProps) {
  const [field, meta] = useField(props.name);
  const { setFieldTouched } = useFormikContext();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    isValidateImmediate && setFieldTouched(field.name, true);
  };

  return (
    <FloatingLabel
      label={
        placeholderHTML ? (
          <span dangerouslySetInnerHTML={{ __html: placeholderHTML }} />
        ) : (
          props.placeholder
        )
      }
      className={classNames(className, {
        "position-relative": !!popoverText || !!prefixIcon,
        label_prefix: !!prefixIcon,
      })}
    >
      <Form.Control
        type="text"
        {...field}
        {...props}
        onChange={handleChange}
        isInvalid={meta.touched && !!meta.error}
        isValid={meta.touched && !meta.error && !!field.value}
        className={classNames("", {
          prefix: !!prefixIcon,
        })}
      />
      <ErrorMessage
        name={props.name}
        component="div"
        className="text-danger error-field"
      />
      {popoverText && (
        <div className="position-absolute top-0 end-0 mt-3 w-auto me-3">
          <PopoverBtn text={popoverText} />
        </div>
      )}
      {prefixIcon && (
        <div className="top-50 left-0 position-absolute translate-middle-y ms-3">
          {prefixIcon}
        </div>
      )}
    </FloatingLabel>
  );
}
